import React from "react";

import { ungrouped } from "./filters";
import { ContentContainer } from "./Picker.styles";
import { IPickerGroup, PickerFilteredItems, PickerItem } from "./Picker.types";
import { ResultGroup } from "./ResultGroup";
import { ResultList } from "./ResultList";

interface IFilteredItemsProps<TTab extends string, TGroup extends string> {
    groups: IPickerGroup<TGroup>[];
    onSelectItem?: (item: PickerItem<TTab, TGroup>) => void;
    indexedItem: PickerItem<TTab, TGroup> | null;
    setIndexedItem: (item: PickerItem<TTab, TGroup>) => void;
    clearIndexedItem: () => void;
    children: PickerFilteredItems<TTab, TGroup>;
}

export function FilteredItems<TTab extends string, TGroup extends string>(
    props: IFilteredItemsProps<TTab, TGroup>,
) {
    const { groups, indexedItem, setIndexedItem, onSelectItem, children } =
        props;

    const content =
        children instanceof Set ? (
            <ResultList
                groups={groups}
                indexedItem={indexedItem}
                setIndexedItem={setIndexedItem}
                onSelectItem={onSelectItem}
            >
                {children}
            </ResultList>
        ) : (
            [...children.entries()].map(([tab, tabItems]) => {
                return (
                    <ResultGroup
                        key={tab.id}
                        heading={tab}
                        hideHeading={children.size === 1 && tab === ungrouped}
                        indexedItem={indexedItem}
                        setIndexedItem={setIndexedItem}
                        showBadges={false}
                        onSelectItem={onSelectItem}
                    >
                        {tabItems}
                    </ResultGroup>
                );
            })
        );

    return <ContentContainer>{content}</ContentContainer>;
}
